import React from 'react';

function Home() {
  return (
    <main>
      <h1>Welcome to our page</h1>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua. Sit amet volutpat
        consequat mauris nunc congue nisi. Amet commodo nulla facilisi nullam
        vehicula ipsum. Sed tempus urna et pharetra pharetra massa massa
        ultricies mi. Mauris ultrices eros in cursus turpis. Risus nec feugiat
        in fermentum posuere urna nec tincidunt praesent. Arcu dui vivamus arcu
        felis bibendum ut tristique et egestas. Eget gravida cum sociis natoque
        penatibus et. Metus dictum at tempor commodo ullamcorper a lacus. Ac
        odio tempor orci dapibus ultrices. Faucibus a pellentesque sit amet
        porttitor. Quam adipiscing vitae proin sagittis nisl rhoncus mattis
        rhoncus. Vel fringilla est ullamcorper eget nulla facilisi etiam
        dignissim diam. Dolor morbi non arcu risus quis varius. Tincidunt id
        aliquet risus feugiat in ante.
      </p>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua. Sit amet volutpat
        consequat mauris nunc congue nisi. Amet commodo nulla facilisi nullam
        vehicula ipsum. Sed tempus urna et pharetra pharetra massa massa
        ultricies mi. Mauris ultrices eros in cursus turpis. Risus nec feugiat
        in fermentum posuere urna nec tincidunt praesent. Arcu dui vivamus arcu
        felis bibendum ut tristique et egestas. Eget gravida cum sociis natoque
        penatibus et. Metus dictum at tempor commodo ullamcorper a lacus. Ac
        odio tempor orci dapibus ultrices. Faucibus a pellentesque sit amet
        porttitor. Quam adipiscing vitae proin sagittis nisl rhoncus mattis
        rhoncus. Vel fringilla est ullamcorper eget nulla facilisi etiam
        dignissim diam. Dolor morbi non arcu risus quis varius. Tincidunt id
        aliquet risus feugiat in ante.
      </p>
    </main>
  );
}

export default Home;
